import styles from './completedStatus.module.scss';

const CompletedStatus = () => {
	return <div className={styles['wrapper']}>CompletedStatus</div>;
};

export default CompletedStatus;
